import React from 'react';
import { __ } from 'i18n/index';

export default function Toasts({ toasts, onDismiss }) {
	return (
		<div className='site-toasts'>
			{toasts.map((toast) => (
				<div
					key={toast.id}
					className={`site-toast site-toast--${toast.kind}`}
					role={toast.kind === 'warning' ? 'alert' : 'status'}
				>
					{toast.user &&
					<span className='site-toast__avatar' aria-hidden='true'>{toast.user.username.charAt(0).toUpperCase()}</span>
					}
					<span className='site-toast__body'>{toast.content}</span>
					<button type='button' className='site-toast__dismiss' aria-label={__('Dismiss')} onClick={() => onDismiss(toast.id)}>
						<i className='fa fa-times' aria-hidden='true' />
					</button>
				</div>
			))}
		</div>
	);
}
